import { BotInfo, BrowserInfo, NodeInfo } from 'detect-browser';
import { CategoryNames, ItemNames, ItemTypes } from '../types';
import {
  DraperyItemDetailsFields,
  DraperyItemDetailsFieldsAction,
} from '../../../redux/modules/my-shop/drapery-item-details-fields-reducer';
import {
  FormFields,
  FormFieldsAction,
  FormFieldsPartial,
} from '../../../redux/modules/my-shop/form-fields-reducer';
import React, { Dispatch, FC, useEffect } from 'react';

import { Category } from '../../../interfaces/category';
import DetailsDescription from './details-description';
import { Supplier } from '../../../interfaces/supplier';
import BundlingSettings from "./bundling-settings";

interface DetailsProps {
  categories: Category[];
  suppliers: Supplier[];
  supplierName: string;
  supplierId: number | undefined | null;
  openModalClick?(): void;
  setSupplierId?: (id: number | null) => any;
  setSupplierName?: (name: string) => any;
  browser: BrowserInfo | BotInfo | NodeInfo | null;
  formFields: FormFields;
  draperyItemDetailsFields: DraperyItemDetailsFields;
  dispatch: Dispatch<FormFieldsAction>;
  dispatchItemDetails: Dispatch<DraperyItemDetailsFieldsAction>;
  copyDispatch?: Dispatch<FormFieldsAction>;
  isEstimateSettingsReadOnly?: boolean;
}

const Details: FC<DetailsProps> = ({
  categories,
  formFields,
  supplierId,
  setSupplierId,
  setSupplierName,
  supplierName,
  draperyItemDetailsFields,
  dispatch,
  dispatchItemDetails,
  copyDispatch,
  isEstimateSettingsReadOnly,
}) => {
  useEffect(() => {
    if (categories && categories.length) {
      const fabricCategory = categories.find((c) => {
        return c.name === CategoryNames.Fabrication;
      });
      if (fabricCategory) {
        const updates = {
          categoryId: fabricCategory.id,
          categoryName: fabricCategory.name,
          name: ItemNames.RomanShade,
          itemTypeId: ItemTypes.Product,
        };

        if (copyDispatch) {
          copyDispatch({
            type: 'updateFormFields',
            formFieldUpdates: updates,
          });
        }

        dispatch({
          type: 'updateFormFields',
          formFieldUpdates: updates,
        });
      }
    }
  }, [categories]);

  useEffect(() => {
    const formFieldUpdates: FormFieldsPartial = {
      supplierId: supplierId,
      supplierName: supplierName,
    };

    dispatch({
      type: 'updateFormFields',
      formFieldUpdates,
    });
  }, [supplierName, supplierId]);

  useEffect(() => {
    if (supplierName === '' && formFields.supplierName !== supplierName) {
      if (setSupplierName) {
        setSupplierName(formFields.supplierName);
      }
      if (setSupplierId) {
        setSupplierId(formFields.supplierId);
      }
    }
  }, [formFields.supplierName, formFields.supplierId]);

  return (
    <div className="flex flex-wrap w-full items-start">
      <div className="w-2/4 mb-6 pr-6"></div>
      <div className="w-full">
        <DetailsDescription
          title="Estimate Description"
          subTitle="Select details to include on estimates."
          optionsGroupName="sales"
          draperyItemDetailsFields={draperyItemDetailsFields}
          dispatch={dispatchItemDetails}
          isEstimateSettingsReadOnly={isEstimateSettingsReadOnly}
        />
        <BundlingSettings
          title="Estimate Bundling"
          subTitle="Choose whether to bundle components on estimates."
          draperyItemDetailsFields={draperyItemDetailsFields}
          dispatchItemDetails={dispatchItemDetails}
          isEstimateSettingsReadOnly={isEstimateSettingsReadOnly}
        />
      </div>
    </div>
  );
};

export default Details;
